import { useMemo } from 'react';
import { useResolvedPath } from 'react-router-dom';

import { Breadcrumb } from '../../../components/Breadcrumb';
import { PageHeader } from '../../../components/PageHeader';
import { PageHeading } from 'components/PageHeading';
import { ITabItem, Tabs } from 'components/tabs/Tabs';
import { useTranslation } from '../../../contexts/translation-context';

export const CustomerPortalSettingsPage = () => {
  const { i18n } = useTranslation();
  const apiKeysRoute = useResolvedPath('api-keys');

  const tabItems = useMemo<ITabItem[]>(() => {
    return [
      {
        title: i18n('customerPortal.apiKeys.apiKeys'),
        path: apiKeysRoute.pathname,
      },
    ];
  }, [i18n, apiKeysRoute.pathname]);

  return (
    <div>
      <PageHeader title={i18n('customerPortal.settings.settings')} />

      <PageHeading leftSide={<Breadcrumb currentItem={i18n('customerPortal.settings.settings')} />} />

      <div className="px-4">
        <Tabs items={tabItems} />
      </div>
    </div>
  );
};
